import * as React from 'react';
import { Footer as StandardFooter, FooterItem } from '@emorg-prd/standard-react';

export default class Footer extends React.Component {

	LinkTo = (url: string, label: string) => (
		<FooterItem     
			url={url}
			value={label}
		/>
	);

	render() {
		return (
			<StandardFooter>
				<FooterItem value='RELATED LINKS' />		
				<FooterItem value='EXPLORE EMIT'/>
				{this.LinkTo('https://goto/cloud', 'goto/cloud')}
				{this.LinkTo('https://goto/AppsHub', 'Applications Hub')}
				{this.LinkTo('https://portal.azure.com', 'Azure Portal')}
			</StandardFooter>
		);
	}
}